import React, { useState } from 'react';
import { ChevronUp, ChevronDown } from 'react-feather';

const FAQSection: React.FC = () => {
    const [openIndices, setOpenIndices] = useState<number[]>([]);
    const [animatingIndices, setAnimatingIndices] = useState<number[]>([]);

    const faqs = [
        {
            question: "Qu'est-ce que le NutriScore ?",
            answer: "Le NutriScore est un label nutritionnel à cinq couleurs qui évalue la qualité nutritionnelle des produits alimentaires de A (meilleur) à E (moins bon). Il a été développé par des scientifiques indépendants pour aider les consommateurs à faire des choix plus sains en un coup d'œil."
        },
        {
            question: "Qu'est-ce que le score NOVA ?",
            answer: "Le score NOVA classe les aliments selon leur degré de transformation en 4 groupes : Groupe 1 (aliments non transformés), Groupe 2 (ingrédients culinaires), Groupe 3 (aliments transformés) et Groupe 4 (aliments ultra-transformés). Il vous aide à identifier les produits les moins transformés pour une alimentation plus saine."
        },
        {
            question: "Qu'est-ce que l'EcoScore ?",
            answer: "L'EcoScore est un système de notation de l'impact environnemental des produits alimentaires, similaire au NutriScore mais axé sur des critères écologiques comme l'empreinte carbone, l'emballage et les méthodes de production. Il utilise aussi une échelle de A (meilleur) à E (moins bon)."
        },
        {
            question: "Quels sites de courses sont compatibles ?",
            answer: "Actuellement, l'extension fonctionne sur Carrefour et Intermarché en France. Nous prévoyons d'ajouter E.Leclerc et Auchan très prochainement. À terme, notre objectif est de couvrir tous les sites de courses en ligne."
        },
        {
            question: "Mes données d’achat sont-elles collectées ?",
            answer: "Non, Le Panier Clair ne collecte ni ne stocke aucune donnée personnelle d’achat. L’extension fonctionne localement dans votre navigateur pour afficher les informations d’OpenFoodFacts sans suivre votre activité."
        }
    ];

    const toggleFAQ = (index: number) => {
        if (openIndices.includes(index)) {
            setAnimatingIndices((prev) => [...prev, index]);
            setTimeout(() => {
                setOpenIndices((prev) => prev.filter(i => i !== index));
                setAnimatingIndices((prev) => prev.filter(i => i !== index));
            }, 1000); // match transition duration
        } else {
            setOpenIndices((prev) => [...prev, index]);
            setAnimatingIndices((prev) => prev.filter(i => i !== index));
        }
    };

    return (
        <section id="faq-section" className="py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">Questions fréquentes</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Retrouvez les réponses aux questions courantes sur Le Panier Clair.
                    </p>
                </div>
                <div className="max-w-3xl mx-auto space-y-4">
                    {faqs.map((faq, index) => {
                        const isOpen = openIndices.includes(index);
                        const isAnimating = animatingIndices.includes(index);
                        return (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                                <button
                                    className="flex justify-between items-center w-full text-left"
                                    onClick={() => toggleFAQ(index)}
                                >
                                    <h3 className="font-medium text-lg">{faq.question}</h3>
                                    {isOpen ? (
                                        <ChevronUp className="text-green-600" />
                                    ) : (
                                        <ChevronDown className="text-green-600" />
                                    )}
                                </button>
                                <div
                                    style={{
                                        maxHeight: isOpen && !isAnimating ? '500px' : isAnimating ? '0px' : '0px',
                                        opacity: isOpen && !isAnimating ? 1 : 0,
                                        overflow: 'hidden',
                                        transition: 'max-height 1s ease, opacity 1s ease',
                                    }}
                                    className="mt-4 text-gray-600"
                                >
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;